import React from 'react'
import ChatbotContainer from './container/ChatbotContainer'
import './styles/chatbot.scss'
import { IntlProvider } from 'react-intl'

const App: React.FC = () => {
	return (
		<IntlProvider messages={{}} locale="it">
			<div
				id="smart-chatbotai-root"
				style={{ position: 'relative', zIndex: 99999 }}>
				<ChatbotContainer />
			</div>
		</IntlProvider>
	)
}

export default App
